import type { Resource } from '../../';
export const country_countries_LT: Resource = {"default":"Lithuania"};
